<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_DEFAULT_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model="detailValue.moduleName"
              :readonly="true"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="detailValue.subModuleName"
              :readonly="true"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model="detailValue.programId"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model="detailValue.programName"
              :readonly="true"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model="detailValue.programType"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_TECHN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model="detailValue.programTechn"
              :readonly="true"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <sui-text-field
              v-model="detailValue.programUseYn"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_CNTN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <textarea
              v-model="detailValue.programContents"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_USR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <cmp-user-name-link
              :pageId="pageId"
              :displayType="'1'"
              :displayLanguageId="detailValue.fstDisplayLanguageId"
              :knoxId="detailValue.fstKnoxId"
              :userName="detailValue.fstUserName"
              :userGlobalName="detailValue.fstUserGlobalName"
              :departmentName="detailValue.fstDepartmentName"
              :departmentEnglishName="detailValue.fstDepartmentEnglishName"
              :type="'link'"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <div class="comm_label">
              {{ detailValue.firstRegistrationDTM }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MDFC_USR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <cmp-user-name-link
              :pageId="pageId"
              :displayType="'1'"
              :displayLanguageId="detailValue.fnlDisplayLanguageId"
              :knoxId="detailValue.fnlKnoxId"
              :userName="detailValue.fnlUserName"
              :userGlobalName="detailValue.fnlUserGlobalName"
              :departmentName="detailValue.fnlDepartmentName"
              :departmentEnglishName="detailValue.fnlDepartmentEnglishName"
              :type="'link'"
            />
          </div>
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MDFC_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-4">
            <div class="comm_label">
              {{ detailValue.finalModificationDTM }}
            </div>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_FILE_INFO') }}</h4>
      </div>
      <sui-grid
        ref="grdfilelist"
        :columns="gridColumns0"
        :dataset="'dsFileLst'"
        :initialPagesize="5"
        :showDisplayCountControl="false"
        :enabletooltips="true"
      />
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_ATTH_FILE') }}</h4>
      </div>
      <div class="mrB10" />
      <cmp-file-attacher
        ref="fileAttacher"
        width="700px"
        :pageId="pageId"
        :showAddDeleteBtn="false"
        :showUpDownArrowBtn="false"
        :attachGroupId="attachGroupId"
        :attachDocumentId="attachDocumentId"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onCancelClick"
      >
        {{ $t('MSG_BTN_CLOSE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

// const dateTypeFields = ['firstRegistrationDTM','finalModificationDTM'];

export default {
  name: 'PGE_CMS_00006_P03', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageId: {
      type: String,
      default: 'PGE_CMS_00006',
    },
    programId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      attachGroupId: 'ATG_CMS_PRGS_COMMON',
      attachDocumentId: '',
      detailValue: {
        moduleName: '',
        subModuleName: '',
        programId: '',
        programName: '',
        programType: '',
        programTechn: '',
        programUseYn: '',
        programContents: '',
        firstRegistrationDTM: '',
        firstRegistrationUserId: '',
        finalModificationDTM: '',
        finalModificationUserId: '',
        displayLanguageId: '',
        knoxId: '',
        userName: '',
        userGlobalName: '',
        departmentName: '',
        departmentEnglishName: '',
      },
      count: 0,
      localdata1: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_FILE_NM'),
        datafield: 'fileName',
      }, {
        text: this.$t('MSG_TXT_FPATH'),
        datafield: 'filePath',
      }, {
        text: this.$t('MSG_TXT_FILE_TYPE'),
        datafield: 'fileTypeName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'fileUseYn',
        width: 80,
      }, {
        text: this.$t('MSG_TXT_CNTN'),
        datafield: 'fileContent',
        width: 200,
      }],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadData() {
      if (utils.isEmpty(this.programId) === false) {
        http.request(this.pageId, 'DTS_CMS_00021', {
          path: {
            'program-id': this.programId,
          },
        }).then(res => {
          // utils.dateformatToClientInArray([res.data], dateTypeFields);

          this.detailValue.moduleName = res.data.moduleName;
          this.detailValue.subModuleName = res.data.subModuleName;
          this.detailValue.programId = res.data.programId;
          this.detailValue.programName = res.data.programName;
          this.detailValue.programType = res.data.programTypeName;
          this.detailValue.programTechn = res.data.programTechnName;
          this.detailValue.programUseYn = res.data.programUseYn;
          this.detailValue.programContents = res.data.programContents;
          this.detailValue.firstRegistrationDTM = utils.dateformatToClient(res.data.firstRegistrationDTM);
          this.detailValue.firstRegistrationUserId = res.data.firstRegistrationUserId;
          this.detailValue.finalModificationDTM = utils.dateformatToClient(res.data.finalModificationDTM);
          this.detailValue.finalModificationUserId = res.data.finalModificationUserId;
          this.detailValue.fstDisplayLanguageId = res.data.fstDisplayLanguageId;
          this.detailValue.fstKnoxId = res.data.fstKnoxId;
          this.detailValue.fstUserName = res.data.fstUserName;
          this.detailValue.fstUserGlobalName = res.data.fstUserGlobalName;
          this.detailValue.fstDepartmentName = res.data.fstDepartmentName;
          this.detailValue.fstDepartmentEnglishName = res.data.fstDepartmentEnglishName;
          this.detailValue.fnlDisplayLanguageId = res.data.fnlDisplayLanguageId;
          this.detailValue.fnlKnoxId = res.data.fnlKnoxId;
          this.detailValue.fnlUserName = res.data.fnlUserName;
          this.detailValue.fnlUserGlobalName = res.data.fnlUserGlobalName;
          this.detailValue.fnlDepartmentName = res.data.fnlDepartmentName;
          this.detailValue.fnlDepartmentEnglishName = res.data.fnlDepartmentEnglishName;

          // this.$refs.fileAttacher.searchAttachedFileInfoByDocId(res.data.atthDocId);
          this.attachGroupId = 'ATG_CMS_PRGS_COMMON';
          this.attachDocumentId = res.data.atthDocId;

          this.dsFileLst.setRawData(res.data.fileList);
        }).catch(error => {
          console.log(error);
        });
      }
    },
    onCancelClick() {
      this.$emit('close');
    },
    columnrenderer() {
      return '<div style="text-align: center; margin-top: 5px;">No data to display</div>';
    },
  },
  datasets: [{
    id: 'dsFileLst',
    type: 'local',
    data: 'localdata1',
    datafields: [{
      name: 'fileName',
      type: 'string',
      map: 'fileName',
    }, {
      name: 'filePath',
      type: 'string',
      map: 'filePath',
    }, {
      name: 'fileTypeName',
      type: 'string',
      map: 'fileTypeName',
    }, {
      name: 'fileUseYn',
      type: 'string',
      map: 'fileUseYn',
    }, {
      name: 'fileContent',
      type: 'string',
      map: 'fileContent',
    }],
  }],
};
</script>
<style scoped>
</style>
